var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_4364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99386 11.9957C6.72575 12.3246 5 14.3004 5 16.7213V18.6327C5 19.3884 5.58154 19.984 6.31892 19.984H17.6817C18.4191 19.984 19 19.3885 19 18.6327V16.7213C19 14.3003 17.2746 12.3242 15.0064 11.9955C14.5011 12.3764 13.9212 12.6636 13.2926 12.8313C12.8819 12.9508 12.4487 13.0149 12.0009 13.0149C11.5605 13.0149 11.1342 12.9529 10.7295 12.8372C10.0925 12.6703 9.50503 12.3809 8.99386 11.9957Z",
    fill: "#A7A7BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z",
    fill: "#A7A7BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_4364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMember);
export default __webpack_public_path__ + "static/media/ic-member.52f6d5674f94164b9568c562d55408e2.svg";
export { ForwardRef as ReactComponent };